<template>
  <el-container class="main-container">
    <el-aside class="sidebar" width="335px" :class="{collapse:isCollapsed}">
      <div class="logo-wrapper">
        <img v-if="!isCollapsed" src="../assets/images/logo.svg" alt="Passport">
        <span v-if="!isCollapsed" class="collapse-wrapper" @click="onClickCollapse">
          <img src="../assets/images/sidebar/collapse.svg" alt="><"/>
        </span>
      </div>
      <span v-if="isCollapsed" class="collapse-wrapper collapsed" @click="onClickCollapse">
          <img src="../assets/images/sidebar/collapse.svg" alt="><"/>
      </span>
      <p class="main-text" :class="{'small-text':isCollapsed}">Asosiy</p>
      <MainNavigation/>
    </el-aside>
    <el-container class="view-container">
      <el-header class="header">
        <HeaderMain/>
      </el-header>
      <el-main class="main-section">
        <div class="page-container" :class="{'no-bg':isHome}">
          <router-view/>
        </div>
      </el-main>
    </el-container>
  </el-container>
</template>

<script>
import MainNavigation from "@/components/MainNavigation";
import HeaderMain from "@/components/Header";

export default {
  name: 'MainContainer',
  components: {HeaderMain, MainNavigation},
  computed: {
    isHome() {
      return this.$route.name === 'HomePage'
    },
    isCollapsed() {
      return !!this.$store.state.collapsed
    }
  },
  methods: {
    onClickCollapse() {
      this.$store.commit("updateCollapsed", !this.$store.state.collapsed)
    }
  }
}
</script>

<style scoped>
.main-container {
  height: 100vh;
}

.logo-wrapper {
  width: 100%;
  padding: 15px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.logo-wrapper > img {
  width: 180px;
}

.collapse-wrapper {
  display: inline-block;
  cursor: pointer;
  transition: all 0.5s;
}

.collapse-wrapper.collapsed {
  transform: rotate(-180deg);
  margin-left: 25px;
  cursor: pointer;
  margin-bottom: 20px;
}

.header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: #FFFFFF;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.03);
  height: 75px;
  border-radius: 10px;
}

.sidebar {
  background: #FFFFFF;
  box-shadow: 10px 0 10px rgba(0, 0, 0, 0.02);
  transition: width 0.3s;
  overflow: hidden;
}

.sidebar > .main-text {
  color: rgba(255, 255, 255, 0.35);
  text-transform: uppercase;
  padding: 15px;
  transition: font-size 0.1s;
}

.sidebar > .main-text.small-text {
  font-size: 12px;
  margin-left: -5px;
}

.sidebar.collapse {
  width: 65px;
}

.view-container {
  background-color: #F2F6F9;
  padding: 15px 20px 0;
}

.main-section {
  padding: 15px 10px;
  margin: 0 -10px;
}

.no-bg {
  background-color: #F2F6F9;
  padding-left: 0;
  margin-right: -10px;
  padding-top: 2px;
}
</style>

